import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum UserRoles {
  SuperAdmin = 'super_admin',
  Staff = 'staff',
  Admin = 'admin',
  Manager = 'manager',
  Worker = 'worker'
}

export enum UserRolesList {
  super_admin = 'SuperAdmin',
  admin = 'Admin',
  manager = 'Manager',
  worker = 'Employee'
}

marker('SuperAdmin');
marker('Admin');
marker('Manager');
marker('Employee');
